export default {"src":"https://webcdn.trailways.ca/_next/static/media/address-brand.8ee9f485.svg","height":14,"width":10,"blurWidth":0,"blurHeight":0};